import * as Yup from "yup";
import { object, array, string, number } from "yup";

export const ProductIntialValues = {
  name: "",
  variationInput: "",
  variations: [],
  // variations: [{ name: '' }],
};


export const ProductValidationSchema = Yup.object()
  .shape({
    name: Yup.string().required("Variant name is required"),
    variationInput: Yup.string().trim().test("unique-name", "This variation already exists!", function (value) {
      const { variations } = this.parent;
      if (!value) return true;
      return variations.every(
        (variation) => variation.name.toLowerCase() !== value?.toLowerCase()
      );
    }),
    variations: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .test(
            "unique-name",
            "Variation names must be unique",
            function (value, context) {
              const { variations } = context.options.context;

              if (!value) return true;
              const names = variations.map((v) => v.name.toLowerCase());
              return names.filter((n) => n === value.toLowerCase()).length <= 1;
            }
          ),
      })
    ).min(1, "Variations value is required"),
  })
  .defined();

export const InsightSearchBarInitialValues = {
  search: "",
  country_id: null,
  type_id: null,
  year: { label: 2023, value: 2023 },
};

export const ProductVariationSearchBarInitialValues = {
  search: "",
};
